// extracted by mini-css-extract-plugin
export default {"content_wrapper":"HTMLToText_content_wrapper__UUzMN","toggle_link":"HTMLToText_toggle_link__qESvJ"};